<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Danh sách chức năng</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
              <li class="breadcrumb-item active">Chức năng</li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="#" class="btn add-btn" data-toggle="modal" data-target="#add_modal">
              <i class="fa fa-plus"></i> Thêm chức năng
            </a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped custom-table mb-0 datatable">
            <thead>
              <tr>
                <th>Mã chức năng</th>
                <th>Tên chức năng</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cn in chucNangs" :key="cn.idChucNang">
                <td>{{ cn.maChucNang }}</td>
                <td>{{ cn.tenChucNang }}</td>
                <td class="text-right">
                  <div class="dropdown dropdown-action">
                    <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown">
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="#" data-toggle="modal" data-target="#edit_modal"
                         @click="editChucNang(cn)">
                        <i class="fa fa-pencil m-r-5"></i> Sửa
                      </a>
                      <a class="dropdown-item" href="#" data-toggle="modal" data-target="#delete_modal"
                         @click="confirmDelete(cn.idChucNang)">
                        <i class="fa fa-trash-o m-r-5"></i> Xóa
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="chucNangs.length === 0 && !loading">
                <td colspan="3" class="text-center">Không có chức năng nào.</td>
              </tr>
              <tr v-if="loading">
                <td colspan="3" class="text-center">Đang tải...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-3">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info">
            Hiển thị {{ currentPage * pageSize + 1 }}
            đến {{ Math.min((currentPage + 1) * pageSize, totalElements) }}
            của {{ totalElements }} mục
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <ul class="pagination">
            <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 0 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage - 1)">Previous</a>
            </li>
            <li v-for="pageNum in totalPages" :key="pageNum"
                class="paginate_button page-item"
                :class="{ active: pageNum === currentPage + 1 }">
              <a href="#" class="page-link" @click.prevent="goToPage(pageNum - 1)">
                {{ pageNum }}
              </a>
            </li>
            <li class="paginate_button page-item next"
                :class="{ disabled: currentPage === totalPages - 1 }">
              <a href="#" class="page-link" @click.prevent="goToPage(currentPage + 1)">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Modal thêm -->
    <div id="add_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="addChucNang">
            <div class="modal-header">
              <h5 class="modal-title">Thêm chức năng</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã chức năng<span class="text-danger">*</span></label>
                <input v-model="newChucNang.maChucNang" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Tên chức năng<span class="text-danger">*</span></label>
                <input v-model="newChucNang.tenChucNang" class="form-control" required />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Thêm</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal sửa -->
    <div id="edit_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <form @submit.prevent="updateChucNang">
            <div class="modal-header">
              <h5 class="modal-title">Sửa chức năng</h5>
              <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Mã chức năng<span class="text-danger">*</span></label>
                <input v-model="currentChucNang.maChucNang" class="form-control" required />
              </div>
              <div class="form-group">
                <label>Tên chức năng<span class="text-danger">*</span></label>
                <input v-model="currentChucNang.tenChucNang" class="form-control" required />
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Lưu</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal xóa -->
    <div id="delete_modal" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body text-center">
            <h3>Bạn có chắc muốn xóa chức năng này?</h3>
            <div class="mt-3">
              <button class="btn btn-danger mr-2" @click="deleteChucNang">Xóa</button>
              <button class="btn btn-secondary" data-dismiss="modal">Hủy</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import api from '@/api/index.js';
import { useToast } from 'vue-toastification';

const toast = useToast();

const chucNangs = ref([]);
const loading = ref(true);

const newChucNang = reactive({ maChucNang: '', tenChucNang: '' });
const currentChucNang = reactive({ idChucNang: null, maChucNang: '', tenChucNang: '' });
const chucNangToDeleteId = ref(null);

const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

const fetchChucNangs = async () => {
  loading.value = true;
  try {
    const res = await api.get('/api/chuc-nang', {
      params: { page: currentPage.value, size: pageSize.value }
    });
    chucNangs.value = res.data.data.content;
    totalElements.value = res.data.data.totalElements;
    totalPages.value = res.data.data.totalPages;
  } catch {
    toast.error('Không thể tải danh sách chức năng');
  } finally {
    loading.value = false;
  }
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchChucNangs();
  }
};

const addChucNang = async () => {
  try {
    await api.post('/api/chuc-nang', newChucNang);
    toast.success('Thêm thành công');
    newChucNang.maChucNang = '';
    newChucNang.tenChucNang = '';
    fetchChucNangs();
  } catch {
    toast.error('Lỗi khi thêm chức năng');
  }
};

const editChucNang = (cn) => {
  Object.assign(currentChucNang, cn);
};

const updateChucNang = async () => {
  try {
    await api.put(`/api/chuc-nang/${currentChucNang.idChucNang}`, currentChucNang);
    toast.success('Cập nhật thành công');
    fetchChucNangs();
  } catch {
    toast.error('Lỗi khi cập nhật');
  }
};

const confirmDelete = (id) => {
  chucNangToDeleteId.value = id;
};

const deleteChucNang = async () => {
  try {
    await api.delete(`/api/chuc-nang/${chucNangToDeleteId.value}`);
    toast.success('Xóa thành công');
    $('#delete_modal').modal('hide');
    fetchChucNangs();
  } catch {
    toast.error('Lỗi khi xóa');
  }
};

onMounted(fetchChucNangs);
</script>
